<div class="rating-range-selector">
  <div class="rating-range-container">
    <!-- Min Rating (Left) -->
    <div class="rating-section min-rating">
      <app-max-test-rating
        [maxRating]="minRating"
        [displayOn2Lines]="true"
        [ratingOrder]="[
          {rating: 0, order: 3},
          {rating: 4, order: 4},
          {rating: 7, order: 1},
          {rating: 10, order: 2}
        ]"
        (onCliCkOnRatingEvent)="onMinRatingChange($event)">
      </app-max-test-rating>
    </div>

    <!-- Divider Line -->
    <div class="rating-divider"></div>

    <!-- Max Rating (Right) -->
    <div class="rating-section max-rating">
      <app-max-test-rating
        [maxRating]="maxRating"
        [displayOn2Lines]="true"
        [ratingOrder]="[
          {rating: 0, order: 3},
          {rating: 4, order: 4},
          {rating: 7, order: 1},
          {rating: 10, order: 2}
        ]"
        (onCliCkOnRatingEvent)="onMaxRatingChange($event)">
      </app-max-test-rating>
    </div>
  </div>
</div>
